module.exports = __webpack_public_path__ + "media/application/images/svgs/check-circle-deacb69181c7e6ca4016abdcaea4136b.svg";